var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadingDash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    fillOpacity: 0.01,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.81225 2.93725C4.09537 3.48736 3.46357 4.14023 2.93725 4.87475L3.93725 5.62475C4.39628 4.98814 4.94341 4.41997 5.56225 3.93725L4.81225 2.93725Z",
    fill: "#D4BBFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.87475 7.68725L1.68725 7.31225C1.38535 8.1756 1.23727 9.08522 1.24975 9.99975H2.49975C2.49721 9.21358 2.6239 8.43233 2.87475 7.68725Z",
    fill: "#D4BBFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.68725 12.7498C1.9771 13.6213 2.39865 14.4433 2.93725 15.1873L3.93725 14.4373C3.48543 13.8046 3.12755 13.1099 2.87475 12.3748L1.68725 12.7498Z",
    fill: "#D4BBFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.87475 17.0623C5.61871 17.6009 6.44073 18.0224 7.31225 18.3123L7.68725 17.1248C6.95209 16.872 6.25739 16.5141 5.62475 16.0623L4.87475 17.0623Z",
    fill: "#D4BBFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31225 1.68725L7.68725 2.87475C8.43233 2.6239 9.21358 2.49721 9.99975 2.49975V1.24975C9.08522 1.23727 8.1756 1.38535 7.31225 1.68725Z",
    fill: "#D4BBFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1248 17.0623C15.8609 16.5136 16.5136 15.8609 17.0623 15.1248L16.0623 14.3748C15.5974 15.0271 15.0271 15.5974 14.3748 16.0623L15.1248 17.0623Z",
    fill: "#D4BBFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1248 12.3123L18.3123 12.6873C18.5841 11.8165 18.7314 10.9117 18.7498 9.99975H17.4998C17.5023 10.7859 17.3756 11.5672 17.1248 12.3123Z",
    fill: "#D4BBFF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2498 7.24975C17.9599 6.37823 17.5384 5.55621 16.9998 4.81225L15.9998 5.56225C16.4516 6.19488 16.8095 6.88959 17.0623 7.62475L18.2498 7.24975Z",
    fill: "#D4BBFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0623 2.87475C14.3183 2.33615 13.4963 1.9146 12.6248 1.62475L12.2498 2.81225C12.9849 3.06505 13.6796 3.42293 14.3123 3.87475L15.0623 2.87475Z",
    fill: "#D4BBFF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6873 18.3123L12.3123 17.1248C11.5672 17.3756 10.7859 17.5023 9.99975 17.4998V18.7498C10.9081 18.6956 11.8086 18.549 12.6873 18.3123Z",
    fill: "#D4BBFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingDash);
export default __webpack_public_path__ + "static/media/LoadingDash.f1e25210fae1cc666c2decfad65e961d.svg";
export { ForwardRef as ReactComponent };